import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { DataProvider } from "./contexts/DataContext";
import { CartProvider } from "./contexts/CartContext";
import { FavoritesProvider } from "./contexts/FavoritesContext";
import { Toaster } from "sonner";
import LenisProvider from "./components/LenisProvider";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GlobalAd from "./components/GlobalAd";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import CartPage from "./pages/CartPage";
import FavoritesPage from "./pages/FavoritesPage";
import AccountPage from "./pages/AccountPage";
import OrdersPage from "./pages/OrdersPage";
import AddressesPage from "./pages/AddressesPage";
import CouponsPage from "./pages/CouponsPage";
import ReviewsPage from "./pages/ReviewsPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentCallbackPage from "./pages/PaymentCallbackPage";
import TrackingPage from "./pages/TrackingPage";
import CourierPage from "./pages/CourierPage";
import AdminLiveTrackingPage from "./pages/AdminLiveTrackingPage";

function AppInner() {
  const location = useLocation();
  const hideGlobalNav = location?.pathname === '/courier';

  return (
    <AuthProvider>
      <DataProvider>
        <CartProvider>
          <FavoritesProvider>
            <LenisProvider>
              <div className="App">
                <Toaster position="top-right" richColors />
                <GlobalAd imageSrc="/image.png" alt="Reklam" />
                {!hideGlobalNav && <Header />}
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/kategori/:slug" element={<CategoryPage />} />
                  <Route path="/urun/:id" element={<ProductDetailPage />} />
                  <Route path="/giris" element={<LoginPage />} />
                  <Route path="/uyelik" element={<RegisterPage />} />
                  <Route path="/sifremi-unuttum" element={<ForgotPasswordPage />} />
                  <Route path="/sifre-sifirla" element={<ResetPasswordPage />} />
                  <Route path="/sepetim" element={<CartPage />} />
                  <Route path="/favorilerim" element={<FavoritesPage />} />
                  <Route path="/hesabim" element={<AccountPage />} />
                  <Route path="/siparislerim" element={<OrdersPage />} />
                  <Route path="/adreslerim" element={<AddressesPage />} />
                  <Route path="/kuponlarim" element={<CouponsPage />} />
                  <Route path="/degerlendirmelerim" element={<ReviewsPage />} />
                  <Route path="/odeme" element={<CheckoutPage />} />
                  <Route path="/track/:token" element={<TrackingPage />} />
                  <Route path="/courier" element={<CourierPage />} />
                  <Route path="/admin/live-tracking" element={<AdminLiveTrackingPage />} />
                  <Route path="/payment/callback" element={<PaymentCallbackPage />} />
                </Routes>
                {!hideGlobalNav && <Footer />}
              </div>
            </LenisProvider>
          </FavoritesProvider>
        </CartProvider>
      </DataProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
